export var SHOW_TYPE;
(function (SHOW_TYPE) {
    SHOW_TYPE[SHOW_TYPE["VERTICAL_DOUBLE"] = 1] = "VERTICAL_DOUBLE";
    // 单排大卡
    SHOW_TYPE[SHOW_TYPE["HORIZONTAL"] = 2] = "HORIZONTAL"; // 横排滑动
})(SHOW_TYPE || (SHOW_TYPE = {}));
export var LIST_STATUS;
(function (LIST_STATUS) {
    LIST_STATUS[LIST_STATUS["SUCCESS"] = 1] = "SUCCESS";
    // 正常态
    LIST_STATUS[LIST_STATUS["LOADING"] = 2] = "LOADING";
    // 加载态
    LIST_STATUS[LIST_STATUS["ERROR"] = 3] = "ERROR"; // 错误态
})(LIST_STATUS || (LIST_STATUS = {}));
export var LOAD_MORE_STATUS;
(function (LOAD_MORE_STATUS) {
    LOAD_MORE_STATUS[LOAD_MORE_STATUS["SUCCESS"] = 1] = "SUCCESS";
    // 正常态
    LOAD_MORE_STATUS[LOAD_MORE_STATUS["LOADING"] = 2] = "LOADING";
    // 加载态
    LOAD_MORE_STATUS[LOAD_MORE_STATUS["ERROR"] = 3] = "ERROR"; // 错误态
})(LOAD_MORE_STATUS || (LOAD_MORE_STATUS = {}));
export var LOAD_MORE_TYPE;
(function (LOAD_MORE_TYPE) {
    LOAD_MORE_TYPE[LOAD_MORE_TYPE["CLICK"] = 1] = "CLICK";
    // 手动加载
    LOAD_MORE_TYPE[LOAD_MORE_TYPE["SCROLL"] = 2] = "SCROLL"; // 自动加载
})(LOAD_MORE_TYPE || (LOAD_MORE_TYPE = {}));
